import { useEffect } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useProfile } from "../Components/Hooks/UserHooks";


const AuthProtected = (props) => {
  const { userProfile, loading, token } = useProfile();
  // Rendered without route props, so `props.location` was always undefined:
  // read the requested location from the router to hand it to the login page.
  const location = useLocation();
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    }
  }, [token, userProfile, loading]);

  /*
    redirect is un-auth access protected routes via url
    */

  if (!userProfile && loading && !token) {
    // Same language rule as useAuth.logout and the session-rejected redirect
    // (i18next's own key). The `lang` cookie read here before was never set
    // by anything, so every redirect went to the French page.
    const lang = localStorage.getItem("i18nextLng");
    const loginPath = lang === "en" || lang === "En" ? "/en/login" : "/fr/connexion";
    return <Redirect to={{ pathname: loginPath, state: { from: location } }} />;
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };